/**
 * Type of all possible regions. Currently we only support region of Table
 */
// eslint-disable-next-line etc/no-const-enum
export enum CompatibleRegionType {

    /**
     * Region split by Table
     */
    Table,
}
